/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import auth from '../app/auth';
import LogoutSuccess from '@/components/LogoutSuccess';
import UserInfoStore from '../app/user-info-store';
import UserInfoApi from '../app/user-info-api';
import ErrorComponent from '@/components/Error';
import HelloWorldEverybody from '@/components/HelloWorldEverybody';
import HelloWorld from '@/components/HelloWorld';

Vue.use(Router)

function requireAuth(to, from, next) {

    if (!auth.auth.isUserSignedIn()) {
        const url = new URL(window.location.href);
        const jwt = url.searchParams.get("jwt");
        if(jwt){
             let redirect_url =  UserInfoApi.getAccessToken(jwt);
                next({
                    path: 'redirect_url',
                    query: { redirect: to.fullPath }
                });
            //if success. just getUserInfo, else redirect to login
        }else{
            UserInfoStore.setLoggedIn(false);
            next({
                path: '/login',
                query: { redirect: to.fullPath }
            });
        }
    } else {
        getUserInfo(to, from, next);
    }
}

function getUserInfo(to, from, next){
    if(auth.auth.isUserSignedIn()){
        UserInfoApi.getUserInfo().then(response => {
            UserInfoStore.setLoggedIn(true);
            UserInfoStore.setCognitoInfo(response);
        });
    }
    next();
}

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: requireAuth
    },
    {
        path: '/hello',

        component: HelloWorld,
        beforeEnter: requireAuth
    },
    {
        path: '/helloeverybody',
        component: HelloWorldEverybody,

    },
    {
        path: '/login', beforeEnter(to, from, next){
            auth.auth.getSession();
        }
    },
    {
        path: '/login/oauth2/code/cognito', beforeEnter(to, from, next){
            let currUrl = window.location.href;
            //console.log(currUrl);
            auth.auth.parseCognitoWebResponse(currUrl);
            //next();
        }
    },
    {
        path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){
            auth.logout();
            next();
        }
    },
    {
        path: '/error', component: ErrorComponent
    }
];

const router = new Router({
    mode: 'history',
    base: '/',
    routes
});

export default router;
